// extracted by mini-css-extract-plugin
export var component = "heading-module--component--+Pyn+";
export var half = "heading-module--half--lxSzk";
export var hr = "heading-module--hr--Jb+yf";
export var light = "heading-module--light--B4K0c";
export var subtitle = "heading-module--subtitle--mFWdO";
export var surtitle = "heading-module--surtitle--vhFIo";
export var title = "heading-module--title--YCsYg";